import {useMemo} from 'react';

export const useAnalytics = (
  logTmrEvent: (eventName: string, params: Record<string, unknown>) => void,
) =>
  useMemo(() => {
    const buttonClick = (location: 'header' | 'footer') => {
      logTmrEvent(location === 'header' ? 'header.click' : 'footer.click', {
        button_text: 'Language',
      });
    };

    const dropdownListClick = ({
      locale,
      location,
    }: {
      locale: string;
      location: 'header' | 'footer';
    }) => {
      logTmrEvent('dropdownList.click', {
        button_text: `Language/${locale}`,
        location,
      });
    };

    return {
      buttonClick,
      dropdownListClick,
    };
  }, [logTmrEvent]);
